export default __webpack_public_path__ + "static/media/digitalBgimg.2571e893.png";